import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { colorLines } from '../../../../reducers/colorLines/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from '../messages';
import { getDropdownOptions } from '../enhance';

const mapStateToProps = combineSelectors({
  colorLines,
});

const options = ({ colorLines, availableOptions }) =>
  getDropdownOptions(colorLines, availableOptions);

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['colorLinesFormPlaceHolder'],
  }),
  connect(mapStateToProps),
  addProps({ options }),
);
